<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap">
			<div class="title">戴尔科技集团</div>
			<div class="line"></div>
			<div class="clear list">
				<div class="clear item" :class="[index >= Math.floor(speaker.length/4) * 4 ? 'end' : '']" v-for="(item,index) in speaker" :key="index" v-if="item.sort >= 100">
					<div class="box2">
						<div class="clear info-box">
              <div class="left avatar">
                <div class="avatar" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
              </div>
							<div class="left info">
								<div class="middle">
									<div class=" m-username">{{item.username}}</div>
									<div class=" m-job" v-html="item.job"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="loading" v-if="data_loading"><loading></loading></div>
			</div>
			<div class="title">特邀嘉宾</div>
			<div class="line"></div>
			<div class="clear list">
				<div class="clear item" :class="[index >= Math.floor(speaker.length/4) * 4 ? 'end' : '']" v-for="(item,index) in speaker" :key="index" v-if="item.sort < 100">
					<div class="box2">
						<div class="clear info-box">
              <div class="left avatar">
                <div class="avatar" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
              </div>
							<div class="left info">
								<div class="middle">
									<div class=" m-username">{{item.username}}</div>
									<div class=" m-job" v-html="item.job"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="loading" v-if="data_loading"><loading></loading></div>
			</div>
			<div class="tips" v-if="speaker.length > 0"><i>* </i>以上演讲嘉宾排名不分先后</div>
		</div>
	</main>
</template>

<script>
import Crumbs from "../../components/m/Crumbs";
import Loading from "../../components/m/Loading";
export default {
	name: 'honored',
	data() {
		return {
			query:"",
			speaker:[],
			data_loading:true,
		}
	},
	components:{
		Loading,
		Crumbs
	},
	computed:{
		crumbs() {
			return {title:"嘉宾介绍",min_title:"Speaker"}
		},
	},
	methods: {
		getGuestList(){
			this.http.request({
				api:"guest/getGuestList",
				data:{},
				success:(res)=>{
					this.speaker = res.list;
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
	},
	mounted() {
		this.getGuestList();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{background: #f1f1f1;padding-top:.5rem;text-align: center;
	.category{text-align: center;display: none;
		.center{ overflow: hidden; padding:0 0 0 .27rem;
			.item{ float:left; margin:0 .27rem .15rem 0; width:2.1rem; height:.6rem;border:.02rem solid #0176ce;line-height:.6rem; font-size:.24rem;color:#565656;cursor: pointer;transition: all .3s ease;}
			.item:nth-last-child(1){margin-right: 0;}
			.item.active{background: #0176ce;color:#fff;transition: all .3s ease;}
		}
	}
	.title{font-size:.32rem;text-align: center}
	.line{width:1.4rem;height:.04rem;margin:.05rem auto 0; background: #1D56C0;}
	.list{margin:.3rem auto 0;
		.item{
			.box1{padding: .4rem;width: 6.2rem;margin: 0 auto;  margin-bottom:.25rem;text-align: left;position: relative;background: #fff;box-shadow: 0 0 .1rem .05rem rgba(0,0,0,.1);
				.username{font-size:.32rem;color:#555555;border-bottom:.02rem solid #d5e3f2;line-height:.4rem;padding-bottom: .1rem;}
				.job{margin-top:.1rem;font-size:.28rem;line-height: .3rem;color:#aaaaaa;white-space: pre-line;}
			}
			.box1::after{content: "";display: block;position: absolute; left:0;top:0;border-top: 20px solid #5ea5e2;border-right: 20px solid transparent;z-index: 3;}
			.box2{width:7rem;margin: 0 auto; margin-bottom: .3rem;text-align: left;position: relative;background: #fff;
				.info-box{padding: .2rem;
					.avatar{width: 2.4rem; height:2.6rem; background-image: url("~@/assets/image/2024/mobile/avatar_default.png"); background-repeat: no-repeat;background-position: center center;background-size: cover;}
					.info{width: 3.95rem;height:2.1rem;padding-left:.25rem;
						.middle{height:2.1rem;
							.m-username{font-size:.3rem;font-weight: bold;}
							.m-job{font-size:.28rem;line-height: .4rem;margin-top: .2rem; color:#565656;white-space: pre-line;}
						}
					}
				}
			}
		}
		.item:hover{
			.hover{height:auto;box-shadow: 0 0 20px 10px rgba(1,118,207,.1);}
		}
		.item.end:hover{
			.hover{bottom:0;top:auto;}
		}
	}
	.tips {padding: 0 .25rem .5rem; font-size:.2rem;text-align: left;color:#999;
		i{color:red;}
	}
}
</style>

